import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ToastController } from '@ionic/angular';

import { Observable, tap } from 'rxjs';

@Injectable()
export class HttpSuccessInterceptor implements HttpInterceptor {
  constructor(
    private toastCtrl: ToastController
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('X-Skip-Success-Interceptor')) {
      return next.handle(request);
    } else if (['POST', 'PUT', 'DELETE'].includes(request.method.toUpperCase())) {
      return next.handle(request).pipe(
        tap(async (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.body.success) {
            const toast = await this.toastCtrl.create(
              {
                message: 'Sucesso!',
                duration: 1500,
                icon: 'checkmark-outline',
                buttons: ['fechar'],
                color: 'success'
              }
            );

            toast.present();
          }
        })
      );
    } else {
      return next.handle(request);
    }
  }
}
